<template>
  <div>
    <header-component />
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform: capitalize">
            Sale Quotations
          </h3>
          <div class="text-right col-lg-12 col-5">
            <div class="table-filters" />
          </div>
        </div>
        <el-table
          :data="userQuotations"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
          border
        >
          <el-table-column label="Customer" prop="name">
            <template slot-scope="scope">{{
              scope.row.user.firstName + " " + scope.row.user.lastName
            }}</template>
          </el-table-column>
          <el-table-column label="Date" prop="date">
            <template slot-scope="scope">{{
              formatDate(scope.row.createdAt)
            }}</template>
          </el-table-column>
          <el-table-column label="Total" prop="total" />
          <el-table-column label="Status">
            <template slot-scope="scope">
              <span v-if="scope.row.status">
                <el-tag
                  v-if="scope.row.status.code === 'pending'"
                  class="pending-status"
                  effect="dark"
                >
                  {{ scope.row.status.label }}
                </el-tag>
                <el-tag
                  v-else-if="scope.row.status.code === 'dispatched'"
                  class="dispatch-status"
                  effect="dark"
                >
                  {{ scope.row.status.label }}
                </el-tag>
                <el-tag
                  v-else-if="scope.row.status.code === 'accepted'"
                  type="success"
                  effect="dark"
                >
                  {{ scope.row.status.label }}
                </el-tag>
                <el-tag
                  v-else-if="scope.row.status.code === 'declined'"
                  class="declined-status"
                  effect="dark"
                >
                  {{ scope.row.status.label }}
                </el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-dropdown
                @command="command => handleAction(scope.row, command)"
              >
                <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>

                <el-dropdown-menu
                  slot="dropdown"
                  class="dropdown-menu dropdown-menu-arrow show"
                >
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                  <el-dropdown-item command="print">Print</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :visible.sync="showSaleQuotationModal"
      title="Sale Quotation Invoice"
      width="50%"
    >
      <sale-quotation-design
        :data="quotationData"
        @close="showSaleQuotationModal = false"
      />
    </el-dialog>
  </div>
</template>
<script>
import headerComponent from "../Components/HeaderComponent";
import { mapActions, mapState } from "vuex";
import dateFns from "date-fns";
import { print } from "@/utils/print";
import SaleQuotationDesign from "./SaleQuotationDesign.vue";

import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button,
  Tag
} from "element-ui";
export default {
  components: {
    [Tag.name]: Tag,
    "header-component": headerComponent,
    // pagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    "sale-quotation-design": SaleQuotationDesign
  },

  data: () => {
    return {
      showSaleQuotationModal: false,
      quotationData: {}
    };
  },
  computed: {
    ...mapState("user", ["userQuotations", "userQuotationMeta"])
  },
  beforeMount() {
    this.getUserQuotations();
  },
  methods: {
    ...mapActions("user", [
      "getUserQuotations",
      "getUserQuotation",
      "printQuotation"
    ]),
    formatDate(value) {
      return dateFns.format(new Date(value), "YYYY-MM-DD");
    },
    async handleAction(userQuotation, command) {
      if (command === "edit") {
        this.$router.push("/sales/quotations/" + userQuotation.userQuotationId);
      }
      if (command === "print") {
        const quotationData = await this.getUserQuotation(
          userQuotation.userQuotationId
        );
        this.showSaleQuotationModal = true;
        this.quotationData = quotationData;
        print(quotationData, "sale-quotation");
      }
    }
  }
};
</script>
<style>
.dispatch-button {
  margin-left: 15px;
  margin-top: 20px;
}
.pending-status {
  background-color: #e72626;
  border-color: #e72626;
  color: #fff;
}
.dispatch-status {
  background-color: #f57316eb;
  border-color: #f57316eb;
  color: #fff;
}
.declined-status {
  background-color: #b0ccb3;
  border-color: #b0ccb3;
  color: #fff;
}
</style>
